import gql from 'graphql-tag'
import { UserFieldsFragment } from '../user/user'
import { UserWithFamilyFieldsFragment } from '../user/userWithFamily'

export const CredentialsFieldsFragment = gql`
  fragment CredentialsFields on Credentials {
    user {
      preferredLanguage
      ...UserFields
      ...UserWithFamilyFields
    }
    accessToken
    refreshToken
    sendbirdAccessToken
  }

  ${UserFieldsFragment}
  ${UserWithFamilyFieldsFragment}
`
